import http from '@/core/http'

const state = {
  itens: [],
  total: {},
}

const headers = { moduloname: 'afiliados' }

const actions = {
  getRelatorio: async ({ commit }, payload) => {
    const result = await http.get('afiliado-relatorio', { params: payload, headers })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },
  limparRelatorio: ({ commit }) => {
    commit('LIMPAR')
  },
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    const data = payload.data || {}
    state.itens = data.resultMap || []
    state.total = data.total || {}
  },

  'LIMPAR' (state) {
    state.itens = []
    state.total = {}
  },
}

const getters = {
  listaItens: state => state.itens,
  totalRow: state => state.total,
  kpiCpa: state => state.total.cpa || 0,
  kpiFtds: state => state.total.ftds || 0,
  kpiRevshare: state => state.total.revshare || 0,
}

export default { namespaced: true, state, actions, mutations, getters }
